import { render, staticRenderFns } from "./sideBarBusiness.vue?vue&type=template&id=abcd948c&scoped=true&"
import script from "./sideBarBusiness.vue?vue&type=script&lang=js&"
export * from "./sideBarBusiness.vue?vue&type=script&lang=js&"
import style0 from "./sideBarBusiness.vue?vue&type=style&index=0&id=abcd948c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcd948c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSheet})
